import { Component } from "react";
import {Form, Button, Row, Col} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {getCountries} from '../../services/userMandatoryFields';
import { USER_DATA } from "../../helpers/constants";
import {postUserGeneralInformation, postUserProfileImage} from '../../services/userInformation';
import {getCurrentUser} from '../../services/authService';
import { WEBSITE_URL } from "../../services/baseService";
import moment from 'moment';
import { toast } from 'react-toastify';
import UserProfileBanner from "./UserProfileBanner";

class UserGeneralInformation extends Component {
    constructor(props) {
        super(props)
        this.state={
            beginDate:new Date(),
            countryList:[],
            gender:[{id:1, name:'Male'}, {id:2, name:'Female'}],
            data:{},
            userData:[],
            currentUser:[],
            image:'',
            userBioInformation:{publicId:'', first_name:'', middle_name:'', last_name:'', dob:new Date(), countryId:'', nationalityId:'', gender:''}
        }
        this.getAllCountries = this.getAllCountries.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.getCurrentUserInformation = this.getCurrentUserInformation.bind(this);
        this.updateUserProfile = this.updateUserProfile.bind(this);

    }

    componentDidMount() {
        try {
            let user = JSON.parse(localStorage.getItem(USER_DATA));            
            this.getAllCountries();
            this.setState({userData:user})
            this.setState({userBioInformation:{...this.state.userBioInformation, publicId:user?.publicId}});
            this.getCurrentUserInformation(user?.publicId);
        }
        catch(error){console.log(error)}
    }
    
    async getAllCountries () {
        await getCountries().then(resp=>this.setState({countryList:resp}));
    }

    updateUserProfile(e) {
        this.setState({image:e.target.files[0]?.name});
        const formData = new FormData();
        formData.append('profile_image', e.target.files[0]);
        formData.append('publicId', this.state.userData?.publicId);
        
        if(e.target.files[0]) {
            this.setState({image:URL.createObjectURL(e.target.files[0])});
            postUserProfileImage(formData).then(response=>response ? toast.success("Profile Image Saved Successfully") : toast.success("")).catch(error => console.log(error, 'error'));
        }
    }
    
    getCurrentUserInformation(userPublicId) {
        getCurrentUser(userPublicId).then(response=>
            {
             
                if (response) {
                    this.setState({currentUser:response});
                    let name = response?.user?.name;
                    let countryId = response?.user?.countryId;
                    let nationalityId = response?.user?.nationality?.id;
                    // let dob =response ? response?.user?.birthday : new Date();  
                    let dob= new Date();
                    const fullDate = moment(dob, 'DD/MM/YYYY').toDate(); /* Convert date into date format from string */                    

                    let gender = response?.user?.sexe == null ? '' : response?.user?.sexe;
                    let allName = name && name.split(' ');

                    this.setState({userBioInformation:{...this.state.userBioInformation, first_name:allName[0], middle_name:allName[1], last_name:allName[2], dob:fullDate, countryId:countryId, nationalityId:nationalityId, gender:gender}});
                } else {
                    console.error(response, "GET USER VERIFIED ERROR")
                }
            }
        ).catch(err=>console.log(err));
    }

    onChange(e) {
        let {name, value} = e.target;
        this.setState({userBioInformation:{...this.state.userBioInformation, [name]:value}})
    }

    onSubmit(e) {
        e.preventDefault();
        let newData = {...this.state.userBioInformation};
        newData.dob = newData.dob.toDateString();
        postUserGeneralInformation(newData).then(response=>
        {
            if(response) {
                toast.success("General Information Saved Successfully");
                setTimeout(()=>{
                    this.props.history.push("/user-biographic-information");
                },1000)
            }
            else {
                toast.success(".");
            }
        }).catch(error=>console.log(error, 'this is new error'));        
    }

    render() {
        let profile_photo_url = this.state.currentUser?.user?.profile_photo_url;
        
        return(
            <>
            <UserProfileBanner />
                <div className="accordion content-accordion" id="userBiographicalInformation">
                    <div key='user_biographical_accordion' className="accordion-item">
                        <h2 className="accordion-header" id='heading'>
                            <button
                                className="accordion-button accordion-btn collapsed"
                                type="button" data-bs-toggle="collapse"
                                data-bs-target='#collapse'
                                aria-expanded="false" aria-controls='collapse'
                            >
                            Informations Générales
                            </button>
                        </h2>
                        <div
                            id='collapse'
                            className="accordion-collapse collapse show"
                            aria-labelledby='heading'
                            data-bs-parent="#userBiographicalInformation"
                        >
                            <div className="accordion-body">
                                <Form onSubmit={this.onSubmit}>
                                    <Row>
                                        <Col className="d-flex flex-wrap align-items-center">
                                            <div className="avatar-xl mb-3 position-relative">
                                                <div style={{ width: '100%', height: '100%', margin:'auto' }}>
                                                    <div className="profile-camera"><i className='bx bx-camera'></i></div>
                                                </div>
                                                {
                                                profile_photo_url ? (
                                                    <span className="avatar-title rounded-circle sidebar-avatar">
                                                        <img className="rounded-circle user-profile-image w-100 h-100" src={this.state.image ? this.state.image : WEBSITE_URL + '' + profile_photo_url} alt="user avatar" />
                                                        <input type="file" name="profile_image" accept="image/*" className="position-absolute w-100 h-100 opacity-0" onChange={this.updateUserProfile} />
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="42" viewBox="0 0 44 42" fill="none">
                                                        <path d="M43.2708 40.385C43.1256 40.6307 42.9169 40.8347 42.6655 40.9765C42.4141 41.1184 42.1289 41.193 41.8386 41.1929H2.16036C1.87029 41.1926 1.58541 41.1178 1.33432 40.9758C1.08323 40.8339 0.874764 40.6299 0.72986 40.3843C0.584957 40.1387 0.508715 39.8601 0.508789 39.5766C0.508864 39.2931 0.585252 39.0146 0.730285 38.7691C3.87768 33.4507 8.72794 29.6371 14.3883 27.8293C11.5884 26.2001 9.41311 23.7177 8.19639 20.7632C6.97967 17.8088 6.78884 14.5456 7.6532 11.4749C8.51755 8.40412 10.3893 5.69559 12.981 3.76524C15.5727 1.83488 18.7411 0.789429 21.9995 0.789429C25.2579 0.789429 28.4263 1.83488 31.018 3.76524C33.6097 5.69559 35.4814 8.40412 36.3458 11.4749C37.2102 14.5456 37.0193 17.8088 35.8026 20.7632C34.5859 23.7177 32.4106 26.2001 29.6107 27.8293C35.2711 29.6371 40.1213 33.4507 43.2687 38.7691C43.4141 39.0145 43.4909 39.2931 43.4912 39.5767C43.4916 39.8604 43.4156 40.1391 43.2708 40.385Z" fill="#B8E5ED"/>
                                                        </svg>
                                                    </span>
                                                ) : (
                                                    <span className="avatar-title rounded-circle sidebar-avatar">
                                                        <img className="rounded-circle w-100 h-100 user-profile-image" src={WEBSITE_URL + '' + this.state.image} alt="user avatar" />
                                                        <input type="file" accept="image/*" name="profile_image" className="position-absolute w-100 h-100 opacity-0" onChange={this.updateUserProfile} />
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="42" viewBox="0 0 44 42" fill="none">
                                                        <path d="M43.2708 40.385C43.1256 40.6307 42.9169 40.8347 42.6655 40.9765C42.4141 41.1184 42.1289 41.193 41.8386 41.1929H2.16036C1.87029 41.1926 1.58541 41.1178 1.33432 40.9758C1.08323 40.8339 0.874764 40.6299 0.72986 40.3843C0.584957 40.1387 0.508715 39.8601 0.508789 39.5766C0.508864 39.2931 0.585252 39.0146 0.730285 38.7691C3.87768 33.4507 8.72794 29.6371 14.3883 27.8293C11.5884 26.2001 9.41311 23.7177 8.19639 20.7632C6.97967 17.8088 6.78884 14.5456 7.6532 11.4749C8.51755 8.40412 10.3893 5.69559 12.981 3.76524C15.5727 1.83488 18.7411 0.789429 21.9995 0.789429C25.2579 0.789429 28.4263 1.83488 31.018 3.76524C33.6097 5.69559 35.4814 8.40412 36.3458 11.4749C37.2102 14.5456 37.0193 17.8088 35.8026 20.7632C34.5859 23.7177 32.4106 26.2001 29.6107 27.8293C35.2711 29.6371 40.1213 33.4507 43.2687 38.7691C43.4141 39.0145 43.4909 39.2931 43.4912 39.5767C43.4916 39.8604 43.4156 40.1391 43.2708 40.385Z" fill="#B8E5ED"/>
                                                        </svg>
                                                    </span>                                    
                                                )}
                                            </div>
                                            <p className="add-user-profile-picture">Add profile picture</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label className="user-information-label">Prénom</Form.Label>
                                                <Form.Control type="text" placeholder="Mr. Xyz" value={this.state.userBioInformation?.first_name} name="first_name" onChange={(e)=>this.onChange(e)} />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="formBasicPassword">
                                                <Form.Label className="user-information-label">Second prénom</Form.Label>
                                                <Form.Control type="text" placeholder="A." name="middle_name" value={this.state.userBioInformation.middle_name} onChange={(e)=>this.onChange(e)} />
                                            </Form.Group>
                                        </Col>
                                        <Col>

                                            <Form.Group controlId="formBasicPassword">
                                                <Form.Label className="user-information-label">Nom de famille</Form.Label>
                                                <Form.Control type="text" placeholder="Mr. Xyz"  name="last_name" value={this.state.userBioInformation.last_name} onChange={(e)=>this.onChange(e)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                    Date de naissance
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 1C3.69 1 1 3.69 1 7C1 10.31 3.69 13 7 13C10.31 13 13 10.31 13 7C13 3.69 10.31 1 7 1Z" fill="#005073"/>
                                                        <path d="M7 3.5C5.89 3.5 5 4.39 5 5.5H6C6 4.95 6.45 4.5 7 4.5C7.55 4.5 8 4.95 8 5.5C8 6.5 6.5 6.38 6.5 8H7.5C7.5 6.88 9 6.75 9 5.5C9 4.39 8.11 3.5 7 3.5Z" fill="#005073"/>
                                                        <path d="M6.99988 10.62C7.3423 10.62 7.61988 10.3424 7.61988 10C7.61988 9.65759 7.3423 9.38 6.99988 9.38C6.65747 9.38 6.37988 9.65759 6.37988 10C6.37988 10.3424 6.65747 10.62 6.99988 10.62Z" fill="#005073"/>
                                                        <path d="M5.5 6C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 5.77614 5.22386 6 5.5 6Z" fill="#005073"/>
                                                        <path d="M7 8.5C7.27614 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.27614 7.5 7 7.5C6.72386 7.5 6.5 7.72386 6.5 8C6.5 8.27614 6.72386 8.5 7 8.5Z" fill="#005073"/>
                                                    </svg>
                                                </Form.Label>
                                                <DatePicker showIcon selected={this.state.userBioInformation?.dob} onChange={(date) => this.setState({userBioInformation:{...this.state.userBioInformation, dob:date}})} />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="country">
                                                <Form.Label className="user-information-label">Pays de résidence</Form.Label>
                                                {
                                                    this.state.countryList && this.state.countryList.length >0 && 
                                                    <Form.Control as="select" required custom onChange={this.onChange} name="countryId" value={this.state.userBioInformation?.countryId}>
                                                        {this.state.countryList?.map((country)=>(<option key={country?.id} value={country?.id}>{country?.name}</option>))}
                                                    </Form.Control>
                                                }
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="formBasicPassword">
                                                <Form.Label className="user-information-label">Nationalité</Form.Label>
                                                {
                                                    this.state.countryList && this.state.countryList.length >0 && 
                                                    <Form.Control as="select" required custom onChange={this.onChange} name="nationalityId" value={this.state.userBioInformation?.nationalityId}>
                                                        {this.state.countryList?.map((country)=>(<option key={country?.id} value={country?.id}>{country?.name}</option>))}
                                                    </Form.Control>
                                                }
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group controlId="formBasicPassword" className="mb-0">
                                                <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                    Gender
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 1C3.69 1 1 3.69 1 7C1 10.31 3.69 13 7 13C10.31 13 13 10.31 13 7C13 3.69 10.31 1 7 1Z" fill="#005073"/>
                                                        <path d="M7 3.5C5.89 3.5 5 4.39 5 5.5H6C6 4.95 6.45 4.5 7 4.5C7.55 4.5 8 4.95 8 5.5C8 6.5 6.5 6.38 6.5 8H7.5C7.5 6.88 9 6.75 9 5.5C9 4.39 8.11 3.5 7 3.5Z" fill="#005073"/>
                                                        <path d="M6.99988 10.62C7.3423 10.62 7.61988 10.3424 7.61988 10C7.61988 9.65759 7.3423 9.38 6.99988 9.38C6.65747 9.38 6.37988 9.65759 6.37988 10C6.37988 10.3424 6.65747 10.62 6.99988 10.62Z" fill="#005073"/>
                                                        <path d="M5.5 6C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 5.77614 5.22386 6 5.5 6Z" fill="#005073"/>
                                                        <path d="M7 8.5C7.27614 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.27614 7.5 7 7.5C6.72386 7.5 6.5 7.72386 6.5 8C6.5 8.27614 6.72386 8.5 7 8.5Z" fill="#005073"/>
                                                    </svg>
                                                </Form.Label>
                                                {
                                                    this.state.gender && this.state.gender.length >0 && 
                                                    <Form.Control as="select" required custom onChange={this.onChange} name="gender" value={this.state.userBioInformation?.gender}>
                                                        {this.state.gender?.map((sex)=>(<option key={sex?.id} value={sex?.name}>{sex?.name}</option>))}
                                                    </Form.Control>
                                                }
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm={8} className="align-items-end d-flex justify-content-end">
                                            <Button variant="primary" className="btn-user-information" type="submit">Sauver et poursuivre</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default UserGeneralInformation;